export const getErrorScripts = async (apiCall, day, limit = 100) => {
  const requestData = {
    day: day,
    limit: limit,
  };

  const response = await apiCall(
    "/assistant/analysis/errorScript/list",
    "POST",
    requestData,
    "admin",
  );

  return response;
};

export const listModels = async apiCall => {
  const response = await apiCall("/assistant/model/list", "POST", {}, "admin");

  return response;
};

export const setCurrentModel = async (apiCall, model) => {
  const requestData = {
    model: model,
  };

  const response = await apiCall(
    "/assistant/model/set",
    "POST",
    requestData,
    "admin",
  );

  return response;
};
